module.exports = __webpack_public_path__ + "img/kx5200-char-1.720ca559.png";